import { debounce } from './debounce';
import { getQueryParams } from './helper';
import { getAuthUrl } from './url-generator';
import { useCheckTextWrap } from './useCheckTextWrap';
import { useScreenType } from './useScreenType';
import { InputValidator, isValidUrl } from './validator';
import { formatRemainderNumber } from './formatAvatarRemainderNumber';
import { useMapProducts } from './useMapProducts';
import { formatUrlForDisplay } from './formatUrlForDisplay';
import { getEnvironment, ENVIRONMENT } from './environment';
import {
  hasProfileConsented,
  hasProfileOwnerConsented,
} from './hasProfileConsented';

export {
  useCheckTextWrap,
  hasProfileConsented,
  hasProfileOwnerConsented,
  useScreenType,
  debounce,
  getQueryParams,
  getAuthUrl,
  isValidUrl,
  formatRemainderNumber,
  useMapProducts,
  InputValidator,
  formatUrlForDisplay,
  getEnvironment,
  ENVIRONMENT,
};
